// extracted by mini-css-extract-plugin
export default {"about":"About_about__zuYW+","container":"About_container__M3CxO"};